import React from 'react';
import classNames from 'classnames';
import styles from '../assets/vendor-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IVendor } from 'src/types/vendor';
import VendorActionsColumn from './VendorActionsColumn';
import DetailVendorColumn from './DetailVendorColumn';
import { CellProps } from 'react-table';
import dateTimeFilter from 'src/components/react-table/filters/datetime-filter';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';

interface Props {
    data: Paginated<IVendor>;
    getData: (params: QueryParams) => void;
}

const columns: Column<IVendor>[] = [
    {
        Header: 'Name',
        accessor: 'name',
        Cell: DetailVendorColumn,
        Filter: textFilter<IVendor>(),
    },

    {
        Header: 'Address',
        accessor: 'address',
        disableSortBy: true,
        Filter: textFilter<IVendor>(),
    },
    {
        Header: 'Contact',
        accessor: 'contact',
        disableSortBy: true,
        Filter: textFilter<IVendor>(),
    },
    {
        Header: 'Email',
        accessor: 'email',
        disableSortBy: true,
        Filter: textFilter<IVendor>(),
    },
    {
        Header: 'Phone',
        accessor: 'phone',
        disableSortBy: true,
        Filter: textFilter<IVendor>(),
    },
    {
        Header: 'Additional',
        accessor: 'info',
        width: '15%',
        disableSortBy: true,
        Filter: textFilter<IVendor>(),
    },

    {
        Header: 'Created',
        accessor: 'createdAt',
        width: '15%',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IVendor>) => changeToZeroMoment(original.createdAt, 'MMM D, YYYY'),
        Filter: dateTimeFilter<IVendor>(),
    },
    {
        Header: 'Actions',
        accessor: 'vendorDocs',
        Cell: VendorActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const VendorsGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => (
    <div className={classNames(styles.grid)}>
        <Grid<IVendor> columns={columns} data={data} getData={getData} />
    </div>
);

export default VendorsGrid;
